<template>
    <div class="tnc-wrapper">
        <h2><span style="font-size: 16pt">Term &amp; Conditions</span></h2>
        <h4>
            <strong><span style="font-size: 12pt">အထွေထွေစည်းကမ်းများ</span></strong>
        </h4>
        <ol>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">ကျွန်ုပ်တို့၏ဝဘ်ဆိုဒ်သည် တစ်ဦးချင်းနေထိုင်သည့်
                        တရားစီရင်ပိုင်ခွင့်တွင် ပြဋ္ဌာန်းထားသည့်အတိုင်း တရားဝင်အသက်အရွယ်ရှိသော ပုဂ္ဂိုလ်များအတွက်သာ
                        ကန့်သတ်ထားသည်။</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">ကျွန်ုပ်တို့၏ဝဘ်ဆိုဒ်သည်
                        ကျွန်ုပ်တို့၏ဝဘ်ဆိုက်ကိုအသုံးပြုသည့်အသုံးပြုသူတိုင်းမှ ချိုးဖောက်ခံရသည့် အမျိုးသားဥပဒေများ၊
                        ဖက်ဒရယ်ဥပဒေများ သို့မဟုတ် နိုင်ငံတကာဥပဒေများအတွက် ကျွန်ုပ်တို့၏ဝဘ်ဆိုဒ်တွင် တာဝန်မရှိပါ။</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">အသုံးပြုသူများသည် ၎င်းတို့၏ကိုယ်ပိုင်လုပ်ဆောင်ချက်များအတွက်
                        တာဝန်ရှိပြီး ပြည်နယ်ဥပဒေများ သို့မဟုတ် ဥပဒေဆိုင်ရာကိစ္စရပ်များပါ၀င်သော ၎င်းတို့၏နိုင်ငံများ၏
                        ဥပဒေများဖြင့် ချည်နှောင်ထားသည်။</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">အေးဂျင့်များအားလုံးသည် ၎င်းတို့၏ သက်ဆိုင်ရာအဖွဲ့ဝင်များ၏
                        အကောင့်များအတွက် တာဝန်ရှိပြီး ၎င်းတို့တင်ပြသော အတည်ပြုထားသော လောင်းကြေးအားလုံးကို
                        ဂုဏ်ပြုရမည်ဖြစ်သည်။</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">အေးဂျင့်များသည် ကျွန်ုပ်တို့၏ဝဘ်ဆိုဒ်၏ မိတ်ဖက်များမဟုတ်ပါ။
                        ထို့ကြောင့် ကျွန်ုပ်တို့၏ဝဘ်ဆိုဒ်သည် ကစားသမားများနှင့် အေးဂျင့်များအကြား ကွဲလွဲမှုများ သို့မဟုတ်
                        အငြင်းပွားမှုများအတွက် တာဝန်မရှိပါ။</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">၎င်း၏ User ID နှင့် Password ကို ခွင့်ပြုချက်မရှိဘဲ အသုံးပြုခြင်းမှ
                        ကာကွယ်ရန် သုံးစွဲသူ၏ တာဝန်ဖြစ်သည်။ အသုံးပြုသူ၏ User ID နှင့် Password ကို ခိုးယူခံရပါက သို့မဟုတ်
                        အခိုးခံရပါက၊ ၎င်း၏ အေးဂျင့်ထံ ချက်ချင်းဆက်သွယ်ရန်မှာ အသုံးပြုသူ၏ တာဝန်ဖြစ်သည်။ ထို့နောက်
                        အေးဂျင့်သည် သူ/သူမအတွက် အသုံးပြုသူ၏ User ID နှင့် စကားဝှက်ကို ပြောင်းလဲလိမ့်မည်။</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">အသုံးပြုသူ ID နှင့် Password ခိုးယူခံရမှုတွင်၊ အသုံးပြုသူသည်
                        ၎င်းတို့၏ သက်ဆိုင်ရာအကောင့်များအတွက် တာဝန်ရှိပြီး အတည်ပြုတင်ပြထားသော လောင်းကြေးအားလုံးကို
                        ဂုဏ်ပြုမည်ဖြစ်သည်။</span>
                </p>
            </li>
        </ol>
        <h4>
            <strong><span style="font-size: 12pt">ဂိမ်းကစားနည်းများ</span></strong>
        </h4>
        <ol>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p><span style="font-size: 10.5pt">ကျွန်ုပ်တို့၏ဝဘ်ဆိုဒ်မှ ဆုံးဖြတ်ထားသော ဂိမ်းရလဒ်များသည်
                        နောက်ဆုံးဖြစ်ပြီး စည်းနှောင်မှုဖြစ်ပါမည်။
                    </span></p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">အငြင်းပွားမှုကိစ္စရပ်တိုင်းတွင်၊
                        ကျွန်ုပ်တို့၏ဝဘ်ဆိုဒ်၏စီမံခန့်ခွဲမှုနှင့် ကစားသမားနှစ်ဦးစလုံးသည် ကျွန်ုပ်တို့၏ဝဘ်ဆိုဒ်
                        ငွေပေးငွေယူမှတ်တမ်းဒေတာဘေ့စ်သည် အငြင်းပွားမှုတွင် နောက်ဆုံးခုံသမာဓိအဖြစ် ဆောင်ရွက်မည်ဖြစ်ကြောင်း
                        သဘောတူရပါမည်။ ပြိုင်ပွဲရလဒ်ကို ဆုံးဖြတ်ပြီးသည့်နေ့တွင် အငြင်းပွားမှုများအားလုံးကို
                        ဖြေရှင်းပေးရမည်။ ပွဲနေ့အပြီးတွင် မည်သည့်တောင်းဆိုမှုကိုမျှ ဂုဏ်ပြုမည်မဟုတ်ပါ။</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">ကစားသမားသည် ၎င်းတို့၏ အကောင့် အရောင်းအ၀ယ်များအားလုံး၏ တိကျမှုကို
                        စစ်ဆေးရန် တစ်ခုတည်းတွင် တာဝန်ရှိပါသည်။</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">ကျေးဇူးပြု၍ သင့်အလောင်းအစားများ အမှားများ၊ အမှားအယွင်းများ သို့မဟုတ်
                        ပျက်ကွက်မှုများအတွက် ၎င်းတို့ကို ကွန်ပျူတာပေါ် မတင်မီ သေချာစွာ စစ်ဆေးပါ။ လောင်းကြေးကို
                        ကွန်ပျူတာမှ လက်ခံပြီးသည်နှင့် ၎င်းကို ပြောင်းလဲခြင်း သို့မဟုတ် ပယ်ဖျက်ခြင်း မပြုနိုင်ပါ။</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">ကျွန်ုပ်တို့သည် ဤစည်းမျဥ်းစည်းကမ်းများကို ဖောက်ဖျက်ရာတွင်
                        တွေ့ရှိရသည့် မည်သည့်ဖောက်သည်၏အကောင့်ကိုမဆို ဖျက်သိမ်းရန်၊ လိမ်လည်သောလှုပ်ရှားမှုများတွင်
                        ပါဝင်ခြင်း၊ ပိုင်နက်ကျူးလွန်ခြင်း၊ တိုက်ခိုက်ခြင်း၊ အတုအယောင်ပြုလုပ်ခြင်း၊ စံစည်းကမ်းများကို
                        ဖောက်ဖျက်ခြင်း သို့မဟုတ် စုပေါင်းလောင်းကစားခြင်းတွင် ပါဝင်ခြင်းတို့ကို ကြိုတင်အသိပေးခြင်းမရှိဘဲ
                        ရရှိလာသော အကောင့်လက်ကျန်အားလုံးကို ခေတ္တရပ်တန့်ကာ ဆုံးရှုံးသွားမည်ဖြစ်ပါသည်။</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">ကျွန်ုပ်တို့သည် အုပ်စုဖွဲ့လောင်းကစားခြင်း၊
                        ညှိနှိုင်းပူးပေါင်းလောင်းကစားခြင်း၊ ပူးပေါင်းကြံစည်ခြင်း၊ လိမ်လည်မှု၊ စနစ်ကို
                        အလွဲသုံးစားပြုခြင်း၊ နည်းပညာဆိုင်ရာအမှားများ သို့မဟုတ် မှားယွင်းသော အလျော်အစားနှုန်းများကို
                        အသုံးချခြင်း၊ သို့မဟုတ် မမျှတသော အားသာချက်ရရှိရန် အခြားမည်သည့်ကြိုးပမ်းမှုနှင့်မဆို
                        ဆက်စပ်နေသည်ဟု တွေ့ရှိရသော လောင်းကြေး သို့မဟုတ် လောင်းကစားလက်မှတ်ကို ပယ်ဖျက်ခြင်း သို့မဟုတ်
                        အကျုံးမဝင်ကြောင်း သတ်မှတ်ခြင်းပြုလုပ်ပိုင်ခွင့်ကို ကျွန်ုပ်တို့ ထိန်းသိမ်းထားသည်။ သက်ဆိုင်ရာ
                        အနိုင်ရငွေများကို ပြန်လည်ရုပ်သိမ်းနိုင်ပြီး သက်ဆိုင်ရာအကောင့်ကို ယာယီရပ်ဆိုင်းခြင်း သို့မဟုတ်
                        ပိတ်သိမ်းခြင်း ပြုလုပ်နိုင်သည်။</span>
                </p>
            </li>
        </ol>
        <h4>
            <strong><span style="font-size: 12pt">အကန့်အသတ်များနှင့် တာဝန်များ</span></strong>
        </h4>
        <ol>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">အထက်ဖော်ပြပါ ယေဘူယျအားဖြင့် ထိခိုက်စေခြင်းမရှိဘဲ၊ ကျွန်ုပ်တို့၏
                        ဝဘ်ဆိုဒ်သည် ပျက်စီးမှုများ၊ အင်အားကြီးမားသည့် ဖြစ်ရပ်နှင့်/သို့မဟုတ်
                        ကျွန်ုပ်တို့၏ဝဘ်ဆိုက်ဗဟိုကွန်ပျူတာစနစ် သို့မဟုတ် မှတ်တမ်းများ သို့မဟုတ် ယင်း၏အစိတ်အပိုင်း
                        သို့မဟုတ် နှောင့်နှေးမှု၊ ဆုံးရှုံးမှု၊ အမှားအယွင်းများ၊ ပျက်ကွက်မှုများ သို့မဟုတ်
                        ဒေတာပေးပို့မှုစနစ် ချို့ယွင်းမှုတစ်ခုခုကြောင့် ထွက်ပေါ်လာသည့် ရလဒ်တစ်ခုခု သို့မဟုတ်
                        ဆက်သွယ်ရေးစနစ်၏ နှောင့်နှေးမှု သို့မဟုတ် အခြားမည်သည့်အရာမှ ထွက်ပေါ်လာသော ယင်းတို့ကို
                        ပျက်ကွက်ခြင်း သို့မဟုတ် အခြားမည်သည့်အရာအတွက်မဆို တာဝန်မယူပါ။ ပြိုင်ပွဲတစ်ခုအတွက်
                        ဝင်ခွင့်လက်ခံခြင်းမဟုတ်ပေ။</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">ကျွန်ုပ်တို့၏ဝဘ်ဆိုဒ်သည် ရန်လိုမှုများ၊ အဓိကရုဏ်းများ၊
                        လူထုမငြိမ်မသက်မှုများ၊ အကြမ်းဖက်ဝါဒ၊ အစိုးရ သို့မဟုတ် အာဏာပိုင်များ (လိုင်စင်ကို ရုပ်သိမ်းခြင်း
                        သို့မဟုတ် ခွင့်ပြုချက်အပါအဝင်) မီးလောင်ပေါက်ကွဲမှု၊ ရေလွှမ်းမိုးမှု၊ ခိုးယူမှု၊ အန္တရာယ်ရှိသော
                        ပျက်စီးမှုများ၊ သပိတ်မှောက်မှု၊ သော့ခတ်မှု၊ ပိတ်ဆို့ခြင်း နှင့် စက်မှုလုပ်ငန်းဆိုင်ရာ
                        လုပ်ဆောင်ချက်တစ်ခုခုကြောင့် ကျွန်ုပ်တို့၏ဝဘ်ဆိုဒ်သည် မည်သည့်ဆုံးရှုံးမှုအတွက်မဆို
                        တာဝန်မကင်းပါ။</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">ကွန်ရက်ချိတ်ဆက်မှု၊ ဆက်သွယ်ရေး၊ စနစ် သို့မဟုတ် လူတို့၏
                        အမှားအယွင်းများဖြစ်သည့် အလောင်းအစားနှင့်ပတ်သက်သည့် ပြဿနာများဖြစ်သည့် လောင်းကြေးထပ်ခြင်းကို
                        လက်ခံခြင်း၊ လောင်းကြေးများကို အတည်မပြုနိုင်ခြင်း၊ ဂိမ်းစတင်ပြီးနောက် အလောင်းအစားများ
                        နေရာပေးခြင်းစသည်ဖြင့် လောင်းကြေးနှင့်ပတ်သက်သည့် ပြဿနာများကို ဖြစ်စေပါသည်။
                        ထိုသို့သောအမှားအယွင်းများဖြစ်ပေါ်ပါက ကိစ္စရပ်အလိုက် ကိုင်တွယ်ဖြေရှင်းရန်နှင့် ထိုအမှားများကို
                        ပြင်ရန် အခြားလုပ်ဆောင်မှုတစ်ခုခု ပြုလုပ်ရန်ကိုလည်း ကျွန်ုပ်တို့မှ အခွင့်ရှိသည်။
                        ထိုသို့သောအမှားအယွင်းများနှင့်စပ်လျဉ်း၍ သင့်ထံ သို့မဟုတ် မည်သည့်ပြင်ပအဖွဲ့အစည်းကိုမျှ
                        ကျွန်ုပ်တို့တွင် တာဝန်ရှိမည်မဟုတ်ပါ။ အကယ်၍ သင်သည် ထိုကဲ့သို့သော အမှားအယွင်းများကို ကြုံတွေ့ပြီး
                        သင်၏ upline သို့ သတင်းမပို့ဘဲ ဆက်လက် လောင်းကြေးထပ်ပါက၊ အမှားများ ထပ်မံ ဖြစ်ပွားပါက
                        အနိုင်ရ/အရှုံး ရလဒ်အားလုံးကို သင် တာဝန်ယူပြီး ဂုဏ်ပြုမည်ဖြစ်ပါသည်။</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">ဤစည်းမျဉ်းများနှင့် စည်းမျဥ်းများသည် ပါတီများကြား သဘောတူညီချက်နှင့်
                        နားလည်မှု တစ်ခုလုံးကို ဖွဲ့စည်းထားသည်။</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">ဤစည်းမျဥ်းများနှင့် စည်းမျဥ်းများ၏ အင်္ဂလိပ်ဘာသာစကားဗားရှင်းနှင့်
                        အခြားဘာသာစကားဗားရှင်းတို့အကြား ကွဲလွဲမှုရှိပါက၊ အင်္ဂလိပ်ဘာသာဗားရှင်းသည် အခြားဘာသာစကားများကို
                        အစားထိုးမည်ဖြစ်ပြီး မှန်ကန်ပြီး မှန်ကန်သည်ဟု မှတ်ယူပါသည်။</span>
                </p>
            </li>
        </ol>
        <BurgerMenu v-if="isMobile" />
    </div>
</template>
<script>
    import BurgerMenu from '@/components/burger-menu.vue';
    import { isMobile } from 'mobile-device-detect';
    export default {
        components: {
            BurgerMenu,
        },
        data: () => {
            return {
                isMobile,
            };
        },
    };
</script>
<style lang="scss" scoped>
    .tnc-wrapper {
        padding: 16px 24px;
        box-sizing: border-box;
        height: calc(100% - 56px);
        overflow-y: auto;
    }

    strong,
    h2,
    h4 {
        font-weight: 600;
    }
</style>
